import {
  AfterViewInit,
  Component,
  effect,
  EventEmitter,
  input,
  InputSignal,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Column, ColumnType } from '@shared/components/simple-table/models/simple-table-model';
import { BehaviorSubject } from 'rxjs';
import {
  CPF_MASK,
  CPF_SIZE,
} from '@shared/constants/cpf-validator.constants';
import { CNPJ_MASK } from '@shared/constants/cnpj-validator.constants';
import { NgSwitch, NgIf, NgSwitchCase, NgFor, NgSwitchDefault, CurrencyPipe, DatePipe } from '@angular/common';
import { StatusColumnComponent } from '../status-column/status-column.component';
import { BooleanColumnComponent } from '../boolean-column/boolean-column.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskPipe } from 'ngx-mask';
import { EmptyValuePipe, TruncatePipe } from '@shared/pipes';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    imports: [NgSwitch, NgIf, NgSwitchCase, StatusColumnComponent, BooleanColumnComponent, MatTooltip, MatFormField, MatSelect, ReactiveFormsModule, FormsModule, NgFor, MatOption, NgSwitchDefault, CurrencyPipe, DatePipe, NgxMaskPipe, EmptyValuePipe, TruncatePipe]
})
export class TableCellComponent implements AfterViewInit {
  readonly ColumnType = ColumnType;
  readonly CPF_MASK = CPF_MASK;
  readonly CNPJ_MASK = CNPJ_MASK;
  readonly CPF_SIZE = CPF_SIZE;

  @Output() statusClick = new EventEmitter<{ row: any; column: Column }>();

  column: InputSignal<Column> = input<Column>({} as Column);
  row: InputSignal<any> = input<any>({});

  index: InputSignal<number> = input<number>(0);

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
  dynamicComponentContainerRef: ViewContainerRef = {} as ViewContainerRef;

  viewInitedSubject = new BehaviorSubject(false);

  ngAfterViewInit(): void {
    this.viewInitedSubject.next(true);
  }

  constructor() {
    effect(() => {
      this.row(); // rastreia mudanças na linha para atualizar componentes dinâmicos
      if (!this.column() || !this.column().component) {
        return;
      }
      this.loadDynamicComponent(this.column().component!.component);
    });
  }

  onStatusActionClick(): void {
    this.statusClick.emit({
      row: this.row(),
      column: this.column(),
    });
  }

  loadDynamicComponent<C>(componentType: Type<C>): void {
    this.viewInitedSubject.asObservable().subscribe((inited) => {
      if (!inited || !this.dynamicComponentContainerRef) {
        return;
      }

      this.dynamicComponentContainerRef.clear();
      const componentRef =
        this.dynamicComponentContainerRef.createComponent(componentType);
      const component = this.column()?.component;
      if (!component) return;
      Object.entries(component?.data ?? {}).forEach(([k, v]) => {
        if (typeof v === 'function') {
          componentRef.setInput(k, v(this.row()));
          return;
        }
        componentRef.setInput(k, v);
      });
      if (component.formControl && component.formArray?.length) {
        componentRef.setInput(
          'formControlRef',
          component.formArray.controls?.[this.index()]?.get(this.column().id)
        );
      }
      componentRef.changeDetectorRef.detectChanges();
    });
  }
}
